import { Switch as AntdSwitch, Flex } from 'antd';
import React from 'react';
import { Label } from '../index';

const Switch = ({
  label = '',
  size = 'default',
  checked = false,
  handleChange = () => {},
  required = false,
  labelSize = 'small',
  labelClassName = '',
  disabled = false,
  ...style
}) => {
  return (
    <Flex align="center" justify="space-between" {...style}>
      {label && (
        <Label size={labelSize} className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      <AntdSwitch disabled={disabled} checked={checked} onChange={handleChange} size={size} />
    </Flex>
  );
};

export default Switch;
